import styled from 'styled-components';
import { calculateGridItemChildWidth } from '../../../commonStyles/innerGridItemColumn';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';
import LazyImg from '../../LazyImg';
import RichText from '../../RichText';

export const Container = styled.div`
  /*  We expect the coloured background to stretch the full width of the view.left
      However, the parent container has a max-width, so we must stretch the container using
      a negative margin and then pad that section of the div.
  */
  padding: ${spacing(4)} 0;
  border-top: 1px solid ${colors.neutral04};

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(4)} calc((100vw - 100%) / 2);
    margin: 0 calc((100% - 100vw) / 2);
  `};
`;

export const StyledGrid = styled(Grid)`
  display: flex;

  ${mediaQuery.tabletPortrait`
    flex-direction: row-reverse;
  `};

  ${mediaQuery.tabletLandscape`
    flex-direction: row;
    align-items: center;
  `};
`;

export const StyledRichText = styled(RichText)`
  a {
    color: ${colors.core02};
  }
  p {
    ${fonts.paragraphSmall};
  }
`;

export const StyledLogo = styled(LazyImg)`
  display: block;
  margin: ${spacing(4)} auto 0;

  ${mediaQuery.tabletPortrait`
    display: inline-block;
    margin: 0;
    width: ${calculateGridItemChildWidth(3, 2, 'tabletPortrait')};
    margin-right: ${calculateGridItemChildWidth(3, 1, 'tabletPortrait')};
  `};

  ${mediaQuery.tabletLandscape`
    display: block;
    margin: 0 0 0 auto;
    width: fit-content;
  `};
`;
